import { render, staticRenderFns } from "./DeliveryGetView.vue?vue&type=template&id=2c336ab2&scoped=true"
import script from "./DeliveryGetView.vue?vue&type=script&lang=ts"
export * from "./DeliveryGetView.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryGetView.vue?vue&type=style&index=0&id=2c336ab2&prod&lang=scss"
import style1 from "./DeliveryGetView.vue?vue&type=style&index=1&id=2c336ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c336ab2",
  null
  
)

export default component.exports